// Attribution: https://reactjs.org/docs/error-boundaries.html

// Dependencies
import React from 'react';

// Services
import { alertService } from 'services/alert';
import { loggerService } from 'services/logger';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// log the error to an error reporting service
		alertService.success('Unknown Error Occurred', { keepAfterRouteChange: true });
		loggerService.trackException(error, { 'Unknown Error Occurred': errorInfo });
	}

	render() {
		if (this.state.hasError) {
			// TODO: customize the fallback UI
			return (
				<div>
					<h1>Unknown Error Occurred.</h1>
					<h2>Please reload the website and try again.</h2>
					<h3>If issues persist, contact Support.</h3>
				</div>
			);
		}

		return this.props.children;
	}
}

export { ErrorBoundary };
